module.exports = __webpack_public_path__ + "common/tp-featured7-89944537a22d3878aef3b70aff6052ea.svg";